import React from 'react';

const BookCover = ({ book, className = '', hideTitle = false, priority = false }) => {
  // If book has a real cover image from the backend, show it
  if (book.coverUrl) {
    return (
      <div className={`relative w-full h-full rounded-lg overflow-hidden shadow-md ${className}`}>
        <img
          src={book.coverUrl}
          alt={`Librito cristiano ilustrado ${book.title} para niños — Museo de la Fe`}
          className="w-full h-full object-cover"
          loading={priority ? "eager" : "lazy"}
        />
        {!hideTitle && (
          <div className="absolute inset-x-0 top-0 bg-white/90 backdrop-blur-sm py-0.5 px-1">
            <p className="text-black/80 text-[7px] sm:text-[8px] font-semibold leading-tight line-clamp-1 text-center">
              {book.title}
            </p>
          </div>
        )}
        <div className="pointer-events-none absolute inset-0 rounded-lg border border-black/[0.06]" />
      </div>
    );
  }

  // Fallback: CSS gradient cover for mock books
  return (
    <div
      className={`relative w-full h-full rounded-lg overflow-hidden shadow-md ${className}`}
      style={{
        background: `linear-gradient(145deg, ${book.coverColors?.[0] || '#6366F1'}, ${book.coverColors?.[1] || '#4F46E5'})`,
      }}
    >
      <div className="absolute top-2 right-2.5 text-white/20 text-lg leading-none select-none" aria-hidden="true">
        {'\u271D'}
      </div>
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, rgba(255,255,255,0.15) 0%, transparent 40%, rgba(0,0,0,0.1) 100%)',
        }}
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center p-3 text-center">
        <h3 className="text-white font-bold text-[10px] sm:text-xs leading-tight drop-shadow-md">
          {book.title}
        </h3>
      </div>
      <div className="absolute bottom-1.5 left-0 right-0 text-center">
        <span className="text-white/30 text-[6px] font-medium tracking-wider uppercase">
          Museo de la Fe
        </span>
      </div>
      <div className="pointer-events-none absolute inset-0 rounded-lg border border-white/10" />
    </div>
  );
};

export default BookCover;
